// @ts-nocheck
/* eslint-disable max-lines-per-function */

import Spinner from '@rio-cloud/rio-uikit/Spinner';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { downloadPdcAttachmentAction } from '@/actions/pdcActions';
import { getPdcAttachments } from '@/selectors';

const AttachmentSpinner = () => (
    <div className='width-30pct content-center height-100'>
        <Spinner />
    </div>
);

const BaseComponent = ({ resourceUrl, contentType, content, downloadAttachment }) => {
    const isLoading = content === undefined || contentType === undefined;

    useEffect(() => {
        downloadAttachment(resourceUrl);
    }, []);

    return (
        <>
            {isLoading && <AttachmentSpinner />}
            {!isLoading && (
                <div className='width-30pct margin-right-2'>
                    <img
                        className='border border-color-lighter width-100pct'
                        src={`data:${contentType};base64, ${content}`}
                    />
                </div>
            )}
        </>
    );
};

BaseComponent.propTypes = {
    resourceUrl: PropTypes.string.isRequired,
    contentType: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    downloadAttachment: PropTypes.func.isRequired,
};

const AttachmentContainer = props => {
    const dispatch = useDispatch();
    const attachment = useSelector(state => getPdcAttachments(state)[props.resourceUrl]);

    return (
        <BaseComponent
            {...props}
            content={attachment?.content}
            contentType={attachment?.contentType}
            downloadAttachment={url => dispatch(downloadPdcAttachmentAction(url))}
        />
    );
};

export { BaseComponent };
export default AttachmentContainer;
